import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-users-dpm',
  templateUrl: './users-dpm.component.html',
  styleUrl: './users-dpm.component.scss'
})
export class UsersDpmComponent {
  constructor(private router: Router) { }
  
  ngOnInit() {
    this.router.navigate(['main/users-dpm/list']);
  }
}
